module.exports = __webpack_public_path__ + "static/media/fuelsensor4.66761890.jpg";